import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {PRIVATE_URL} from "../../common/struct/urlManager";
import Page from "../../patterns/page/page";
import SelectCompany from "../selectCompany/selectCompany";
import ApartmentIcon from '@mui/icons-material/Apartment';
import SuperAdminCompanies from './companies/superAdminCompanies';
import KeyIcon from '@mui/icons-material/Key';
import SuperAdminCodes from "./codes/superAdminCodes";
import {isSuperAdmin} from "../../common/struct/globalVar";


export enum SuperAdminMenu {
  DEFAULT = "home",
  COMPANIES = "companies",
  CODES = "codes"
}

export default function SuperAdminHome(): JSX.Element {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (!isSuperAdmin()) {
      navigate(PRIVATE_URL.LANDING_PAGE, {replace: true});
    }
  }, []);

  const extractSelectedMenu = (): SuperAdminMenu|null => {
    switch (location.pathname) {
    case PRIVATE_URL.SUPER_ADMIN_HOME:
      return SuperAdminMenu.DEFAULT;
    case PRIVATE_URL.SUPER_ADMIN_COMPANIES:
      return SuperAdminMenu.COMPANIES;
    case PRIVATE_URL.SUPER_ADMIN_CODES:
      return SuperAdminMenu.CODES;
    default:
      navigate(PRIVATE_URL.SUPER_ADMIN_COMPANIES);
      return null;
    }
  }

  const [selectedMenu, setSelectedMenu] = useState(extractSelectedMenu());

  const initMenu = [{
    icon: ApartmentIcon,
    label: 'super_admin.home.title',
    url: PRIVATE_URL.SUPER_ADMIN_HOME
  },{
    icon: ApartmentIcon,
    label: 'super_admin.companies.title',
    url: PRIVATE_URL.SUPER_ADMIN_COMPANIES
  },{
    icon: KeyIcon,
    label: 'super_admin.codes.title',
    url: PRIVATE_URL.SUPER_ADMIN_CODES
  }];

  useEffect(() => {
    setSelectedMenu(extractSelectedMenu());
  }, [location]);

  return (
    <Page title={t('select_company.title')} menus={initMenu}>
      <>
        {selectedMenu === SuperAdminMenu.COMPANIES.toString() &&
          <SuperAdminCompanies />
        }
        {selectedMenu === SuperAdminMenu.DEFAULT.toString() &&
          <SelectCompany />
        }
        {selectedMenu === SuperAdminMenu.CODES.toString() &&
          <SuperAdminCodes />
        }
      </>
    </Page>
  );
}
